import { memo } from 'react';
import { Collapse } from '@material-ui/core';
import { BorderedBox, BorderedBoxTitle, ToggleButton } from 'components';
import { useStyles } from './style';

interface Props {
  open: boolean;
  title: string | null;
  handleClick: (id: string | null) => void;
}

const ProviderCollapseBlock: React.FC<Props> = ({
  open,
  title,
  handleClick,
  children,
}) => {
  const classes = useStyles();

  return (
    <BorderedBox className={classes.borderBox}>
      <div className={classes.topBar} onClick={() => handleClick(title)}>
        <BorderedBoxTitle>{title}</BorderedBoxTitle>
        <ToggleButton dir={open ? 'up' : 'down'} background="transparent" />
      </div>
      <Collapse in={open} timeout="auto">
        {children}
      </Collapse>
    </BorderedBox>
  );
};

export default memo(ProviderCollapseBlock);
